/* eslint-disable class-methods-use-this */
/* eslint-disable radix */
if (!customElements.get("filter-dropdown-item")) {
  class FilterDropDownItemElement extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.content = this.querySelector(".filter-dropdown-list__item");
      this.selected = 0;
      this.selectedFiltersValues = [];
      const firstNonSearchInput = this.querySelector("input:not(.js-filter-search)");
      if (firstNonSearchInput && firstNonSearchInput.type === "text") {
        this.priceFilter = true;
      }
    }

    connectedCallback() {
      this.init();
      this.populateSelectedFilters();
    }

    disconnectedCallback() {
      // Cleanup: remove the event listener when the element is removed from the DOM
      const header = this.querySelector(".filter-dropdown-item__header");
      if (header) {
        header.removeEventListener("click", this.handleClick);
      }
    }

    init() {
      this.initDropdown();
      this.querySelectorAll("input").forEach((target) => {
        target.addEventListener("change", (e) => {
          if (!(e.detail && e.detail.message === "init")) {
            if (this.priceFilter) {
              this.checkboxChangePrice(target);
            } else if (target.type === "radio") {
              this.radioChange(target);
            } else {
              this.checkboxChange(target);
            }
          }
        });
      });
    }

    populateSelectedFilters() {
      this.querySelectorAll("input").forEach((target) => {
        if (target.checked) {
          if (this.priceFilter) {
            this.checkboxChangePrice(target, false);
          } else {
            this.checkboxChange(target, false);
          }
        }
      });
    }

    sendUpdateEvent(type, sortValue = "") {
      // i want to pass
      if (sortValue !== "") {
        const eventFilterUpdate = new CustomEvent("filterUpdate", {
          bubbles: true,
          detail: {
            type,
            element: this,
            sortValue,
          },
        });
        this.dispatchEvent(eventFilterUpdate);
        return;
      }
      const eventFilterUpdate = new CustomEvent("filterUpdate", {
        bubbles: true,
        detail: {
          type,
          element: this,
        },
      });
      this.dispatchEvent(eventFilterUpdate);
    }

    checkboxChangePrice(target, sendEvents = true) {
      this.selectedFiltersValues = [];
      const inputRange = target.closest("filter-price");

      if (!inputRange) {
        return;
      }

      const min = inputRange.getAttribute("min");
      const max = inputRange.getAttribute("max");

      if (target.type === "range") {
        const inputs = target.parentElement.parentElement.parentElement.querySelectorAll("input[type='text']");
        let targetAttribute = "";
        inputs.forEach((input) => {
          if (
            input.getAttribute("data-filter-to-add") === "filter.v.price.gte=" &&
            parseFloat(input.value).toFixed(2) !== parseFloat(min).toFixed(2)
          ) {
            targetAttribute = input.getAttribute("data-filter-to-add") + parseFloat(input.value);
            this.selectedFiltersValues.push(targetAttribute);
          } else if (
            input.getAttribute("data-filter-to-add") === "filter.v.price.lte=" &&
            parseFloat(input.value).toFixed(2) !== parseFloat(max).toFixed(2)
          ) {
            targetAttribute = input.getAttribute("data-filter-to-add") + parseFloat(input.value);
            this.selectedFiltersValues.push(targetAttribute);
          }
        });
        if (sendEvents) {
          this.sendUpdateEvent("price");
        }
      } else {
        const inputs = target.parentElement.parentElement.querySelectorAll("input[type='text']");
        let targetAttribute = "";
        inputs.forEach((input) => {
          if (
            input.getAttribute("data-filter-to-add") === "filter.v.price.gte=" &&
            parseFloat(input.value).toFixed(2) !== parseFloat(min).toFixed(2)
          ) {
            targetAttribute = input.getAttribute("data-filter-to-add") + parseFloat(input.value);
            this.selectedFiltersValues.push(targetAttribute);
          } else if (
            input.getAttribute("data-filter-to-add") === "filter.v.price.lte=" &&
            parseFloat(input.value).toFixed(2) !== parseFloat(max).toFixed(2)
          ) {
            targetAttribute = input.getAttribute("data-filter-to-add") + parseFloat(input.value);
            this.selectedFiltersValues.push(targetAttribute);
          }
        });
        if (sendEvents) {
          this.sendUpdateEvent("price");
        }
      }
    }

    checkboxChange(target, sendEvents = true) {
      const targetAttribute = this.stripRelevantURL(target.getAttribute("data-filter-to-add"));
      this.targetAttribute = targetAttribute;
      if (target.checked) {
        this.selected += 1;
        this.selectedFiltersValues.push(targetAttribute);
      } else {
        this.selected -= 1;
        const indexToDelete = this.selectedFiltersValues.indexOf(targetAttribute);
        this.selectedFiltersValues.splice(indexToDelete, 1);
      }
      if (sendEvents) {
        this.sendUpdateEvent("checkbox");
      }
    }

    radioChange(target, sendEvents = true) {
      const targetAttribute = this.stripRelevantURL(target.getAttribute("data-filter-to-add"));
      this.targetAttribute = targetAttribute;
      this.selectedFiltersValues = [targetAttribute];
      if (sendEvents) {
        this.sendUpdateEvent("sort-input", targetAttribute);
      }
    }

    stripRelevantURL(url) {
      const newUrl = url.slice(url.indexOf("?") + 1);
      return newUrl;
    }

    getFilterURLs() {
      return this.selectedFiltersValues;
    }

    initDropdown() {
      const header = this.querySelector(".filter-dropdown-item__header");
      if (header) {
        header.addEventListener("click", this.handleClick);
      }
    }

    handleClick() {
      if (this.classList.contains("filter-dropdown-item--open-default")) {
        if (window.innerWidth > 1024) {
          this.classList.remove("filter-dropdown-item--open-default");
          return;
        }
        this.classList.remove("filter-dropdown-item--open-default");
      }
      this.classList.toggle("filter-dropdown-item--open");
    }
  }

  customElements.define("filter-dropdown-item", FilterDropDownItemElement);
}
